///<reference path="../common/data-template-base.ts"/>

module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;
    import Variant = Model.Variant;
    import Manufacturer = Model.Manufacturer;
    import ProductCategory = Model.ProductCategory;

    export class ProductVariantsDataTemplate extends DataTemplateBase implements IDataTemplate {

        protected manufacturers: ManufacturersCollection;
        protected productCategories: ProductCategoriesCollection;
        protected productVariants: ProductVariantsCollection;

        public title: string;
        public allSelectedLabel: string;
        public totalSelectedMessage: string;

        get collection() {
            return this.manufacturers;
        }

        get leafCollection() {
            return this.productVariants;
        }

        reconnectLeafCollectionModel(model) {
            this.leafCollection.connectedModel = model[this.properties[2]];
        }

        get totalSelectedCount() {
            return this.productVariants.value.length;
        }

        constructor(model: Dictionary<any>, properties: string[], { criteria }) {
            super(model, properties, criteria);

            this.manufacturers = new ManufacturersCollection(this.model[properties[0]],
                [],
                {
                    criteria
                });

            this.productCategories = new ProductCategoriesCollection(this.model[properties[1]],
                [],
                {
                    criteria
                });

            this.productVariants = new ProductVariantsCollection(this.model[properties[2]], [], {
                criteria,
                smartMoverHidden: () => this.smartMoverHidden
            });
            this.productVariants.on('sync', this.onVariantChange.bind(this));
            this.productCategories.setParentCollection(this.manufacturers, CoreProductCatToManufacturersStrategy);
            this.productVariants.setParentCollection(this.productCategories, ProductVariantToProductCatStrategy);

            this.title = 'LABEL_PRODUCTS';
            this.allSelectedLabel = 'LABEL_ALL_PRODUCTS';
            this.totalSelectedMessage = 'LABEL_PRODUCTS_SELECTED';
        }

        protected onVariantChange(models: CollectionModel<Variant>[], dataService: Meevo.Components.BaseClasses.IDataService)
        {
            let realCategories = {};
            for (const variant of this.productVariants.responseList) {
                let key = `${variant.categoryId}${variant.manufacturerId}`;
                if (realCategories[key]) {
                    continue;
                }
                let category = this.productCategories.responseList.find(cat => cat.id == variant.categoryId);
                if (category) {
                    let clone = _(category).clone();
                    clone.manufacturerId = variant.manufacturerId;
                    realCategories[key] = clone;
                }
            }
            this.productCategories.handleResponse(Object.keys(realCategories).map(key => realCategories[key]));
            this.productVariants.handleResponse(this.productVariants.responseList);
        }


        setWatchers(scope: angular.IScope) {
            this.productCategories.setWatchers(scope);
            this.productVariants.setWatchers(scope);

            super.setWatchers(scope);
        }
    }
}